import type { Account } from '@/types/serializers'
import ClientSummary from '../_components/ClientSummary'
import CompanyInformation from '../_components/CompanyInformation'
import ContactInformation from '../_components/ContactInformation'

interface OverviewTabProps {
  account: Account
}

export default function OverviewTab({ account }: OverviewTabProps) {
  return (
    <div className="space-y-8">
      <ClientSummary account={account} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CompanyInformation account={account} />
        <ContactInformation account={account} />
      </div>
    </div>
  )
}